import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

export function ErrorBoundaryFallback() {
  const handleReload = () => {
    window.location.reload()
  }

  return (
    <div className="bg-muted/30 flex min-h-screen items-center justify-center px-6 py-10">
      <Card className="w-full max-w-lg" role="alert">
        <CardHeader>
          <CardTitle>Something went wrong</CardTitle>
          <CardDescription>
            The app hit an unexpected error. Reloading usually fixes things.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          If this keeps happening, let the Honey Show team know what you were doing.
        </CardContent>
        <CardFooter>
          <Button type="button" onClick={handleReload}>
            Reload
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
